import { render, staticRenderFns } from "./Trello.vue?vue&type=template&id=476b157d&scoped=true&"
import script from "./Trello.vue?vue&type=script&lang=ts&"
export * from "./Trello.vue?vue&type=script&lang=ts&"
import style0 from "./Trello.vue?vue&type=style&index=0&id=476b157d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b157d",
  null
  
)

export default component.exports